import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {  LocalPricePackages, pricePackages } from "../../utils/constants";


const validationSchema = Yup.object({
  zone_ids:Yup.array().min(1).required("Zones is required"),
  package_type: Yup.string().min(1).required("Package Type is required"),
  package_weeks: Yup.number().required('Package weeks is required'),
  creative_type: Yup.string().required("Creative type is required"),
  position: Yup.number().when('package_type', {
    is: (val) => ['Alpha', 'Local', 'Inbound'].includes(val),
    then: (schema) => schema.required('Position is required!'),
    otherwise: (schema) => schema.notRequired().nullable().transform((value, originalValue) => {
      return originalValue === '' ? 0 : value;
    })
  })
});
function ZonePackage({
  packageValue,
  setPackageValue,
  setPackageDetails,
  packageDetails,
  disable,
  salesType,
  updatedPackageValue,
  setUpdatedPackageValue,
  flag
}) {
  const [zoneOptions, setZoneOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(false); // detect first render
  const [formChanged, setFormChanged] = useState(false)

  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      zone_ids: [],
      package_type:"",
      creative_type: "",
      position: "",
      package_weeks: "",

    },
  });
  const watchedValues = watch()
  const positionOptions = [
    { label: "1", value: "1" },
    { label: "3", value: "3" },
    { label: "5", value: "5" },
    { label: "9", value: "9" },
    { label: "12", value: "12" },
    { label: "15", value: "15" },
    { label: "19", value: "19" },
    { label: "23", value: "23" },
    { label: "27", value: "27" },
  ];
  // Utility: calculate percent change
  function percentChange(a, b) {
    if (!a && !b) return 0;
    if (a === 0) return b > 0 ? Infinity : -Infinity;
    return ((b - a) / a) * 100;
  }

  // Fetch available zones
  useEffect(() => {
    const fetchZones = async () => {
      try {
        let res = await API({
          url: "/zones//zone-options",
          method: "POST",
          responseType: "json",
          data: { salesType },
        });
        if (res.code === 200) {
         
          setZoneOptions(res.data);
        }
      } catch (error) {
        console.error(error);
        Toast("error", "Failed to fetch zones");
      }
    };
    fetchZones();
  }, [salesType]);

  // Function to fetch package value based on zones
  const onSubmit = async (data) => {
    if (!data.package_type || !data.package_weeks || !data.creative_type || !data.zone_ids?.length) {
      setPackageValue(0);
      return;
    }
    console.log("form submitted")
    try {
    setFormChanged(true)
      const res = await API({
        url: '/packagerates/getzonesprice',
        method: 'POST',
        responseType: 'json',
        data: {
          ...data
        }
      });
      
      if (res.code === 200) {
        setPackageValue(res.data);
        if(formChanged)
        setUpdatedPackageValue(res.data)
        if(!updatedPackageValue)setUpdatedPackageValue(res.data)
        if (res.data === 0) {
          Toast('error', "No data found");
          return;
        }
        setPackageDetails({...data,salesType});
      }
    } catch (error) {
      console.error(error);
      Toast('error', "Error while fetching prices");
    }
  };

  const handleFormSubmissionWithReset = async (fieldName, newValue) => {
    if (isInitialLoad) return;
    
    // Reset package value immediately when any field changes
    setPackageValue(0);
    setTimeout(async () => {
      // Get current form values
      const currentValues = watch();
      
      // Check if all required fields are filled
      const hasRequiredFields =
        currentValues.zone_ids?.length > 0 &&
        currentValues.package_type &&
        currentValues.package_weeks &&
        currentValues.creative_type &&
        (['Alpha', 'Local', 'Inbound'].includes(currentValues.package_type) ? currentValues.position : true);
      
      if (hasRequiredFields) {
        console.log("All required fields present, submitting...");
        handleSubmit(onSubmit)();
      } else {
        console.log("Missing required fields, package value remains 0");
        // Package value is already 0 from the reset above
      }
    }, 1000);
  };
  const getSelectValues = (options, field, fieldValue) => {
    if (options.length > 0 && fieldValue && Array.isArray(fieldValue)) {
      switch (field) {
        case "zone_ids":
          // fieldValue is array of strings/numbers
          return options.filter((option) => fieldValue.some(val => val === option.value));
        
        default:
          return [];
      }
    } else {
      return [];
    }
  };
  // Handle package details autofill - FIXED VERSION
  useEffect(() => {
    const loadPackageDetails = async () => {
      if (Object.keys(packageDetails).length > 0) {
        setIsLoading(true);
        setIsInitialLoad(true);
        
        try {
          // Set basic form values first
          
          setValue("package_type", packageDetails.picked_package ? packageDetails.picked_package : packageDetails.package_type);
          setValue("creative_type", packageDetails.creative_type);
          setValue("position", `${packageDetails.position}`);
          setValue("package_weeks", packageDetails.package_weeks);
          if(packageDetails.zone_ids?.length){
          setValue("zone_ids", packageDetails.zone_ids);
          }
          handleSubmit(onSubmit)();
          setIsInitialLoad(false);
          setIsLoading(false);
        } catch (error) {
          console.error("Error loading package details:", error);
          setIsInitialLoad(false);
          setIsLoading(false);
        }
      }
    };

    loadPackageDetails();
  }, [flag]);
  return (
    <div className="my-2">
      <form onSubmit={handleSubmit(() => {})} className="space-y-4">
      <h5>Package Type: <span className="capitalize">{watchedValues.package_type ==='Classified' ? 'Classified' : salesType}</span> </h5>
        <div>
          <label className="form-label">Price Package Type</label>
          <br />
          {salesType === "Alpha" && <><div className="form-check form-check-inline">
            <Controller
              name="package_type"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  className="form-check-input"
                  type="radio"
                  id="Alpha"
                  value="Alpha"
                  checked={field.value === "Alpha"}
                  disabled={disable}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setValue('creative_type', '');
                    setPackageValue(0);
                    handleSubmit(onSubmit)();
                  }}
                />
              )}
            />
            <label className="form-check-label" htmlFor="Alpha">
              Alpha
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Controller
              name="package_type"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  className="form-check-input"
                  type="radio"
                  id="Local"
                  value="Local"
                  checked={field.value === "Local"}
                  disabled={disable}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setValue('creative_type', '');
                    setPackageValue(0);
                    handleSubmit(onSubmit)();
                  }}
                />
              )}
            />
            <label className="form-check-label" htmlFor="Local">
              Local
            </label>
          </div>
          </>}
          {salesType === "Inbound" && <div className="form-check form-check-inline">
            <Controller
              name="package_type"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  className="form-check-input"
                  type="radio"
                  id="Inbound"
                  value="Inbound"
                  checked={field.value === "Inbound"}
                  disabled={disable}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setValue('creative_type', '');
                    setPackageValue(0);
                    handleSubmit(onSubmit)();
                  }}
                />
              )}
            />
            <label className="form-check-label" htmlFor="Inbound">
              Inbound
            </label>
          </div>}
          {salesType === "Local" &&<> <div className="form-check form-check-inline">
            <Controller
              name="package_type"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  className="form-check-input"
                  type="radio"
                  id="Local"
                  value="Local"
                  checked={field.value === "Local"}
                  disabled={disable}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setValue('creative_type', '');
                    setPackageValue(0);
                    handleSubmit(onSubmit)();
                  }}
                />
              )}
            />
            <label className="form-check-label" htmlFor="Local">
              Local
            </label>
          </div>
          <div className="form-check form-check-inline">
          <Controller
            name="package_type"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                className="form-check-input"
                type="radio"
                id="Alpha"
                value="Alpha"
                checked={field.value === "Alpha"}
                disabled={disable}
                onChange={(e) => {
                  field.onChange(e.target.value);
                  setValue('creative_type', '');
                  setPackageValue(0);
                  handleSubmit(onSubmit)();
                }}
              />
            )}
          />
          <label className="form-check-label" htmlFor="Alpha">
            Alpha
          </label>
        </div></>}
          <div className="form-check form-check-inline">
            <Controller
              name="package_type"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  className="form-check-input"
                  type="radio"
                  id="classified"
                  value="Classified"
                  checked={field.value === "Classified"}
                  disabled={disable}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setValue('creative_type', '');
                    setPackageValue(0);
                    handleSubmit(onSubmit)();
                  }}
                />
              )}
            />
            <label className="form-check-label" htmlFor="classified">
              Classified
            </label>
          </div>
        </div>
        {errors.package_type && (
          <p className="text-red-600">{'Package type was required'}</p>
        )}
      <h5 className="text-lg font-semibold mb-4">Zone Targets</h5>

        {/* Zone Multi Select */}
        <div>
          <label htmlFor="zone_ids" className="block font-medium mb-1">
            Zones
          </label>
          <Controller
            name="zone_ids"
            control={control}
            rules={{ required: "Please select at least one Zone" }}
            render={({ field }) => (
              <Select
                {...field}
                isMulti
                options={zoneOptions}
                placeholder="Select Zones"
                isDisabled={disable}
                value={getSelectValues(zoneOptions, "zone_ids", field.value || [])}
                onChange={(selected) => {
                  const values = selected ? selected.map((item) => item.value) : [];
                  field.onChange(values);
                  if (!isInitialLoad) {
                    handleFormSubmissionWithReset('zone_ids', values);
                  }
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                
              />
            )}
          />
          {errors.zone_ids && (
            <p className="text-red-600 text-sm mt-1">
              {errors.zone_ids.message}
            </p>
          )}
        </div>

        {(['Alpha', 'Local', 'Inbound'].includes(watchedValues.package_type)) && <div className="mb-3">
          <label htmlFor="" className="form-label">
            Position
          </label>
          <span className="text-red-600">*</span>
          <Controller
            name="position"
            control={control}
            render={({ field }) => (
              <select
                {...field}
                className="form-select"
                onChange={(e) => {
                  field.onChange(e.target.value);
                  if (!isInitialLoad) {
                      handleFormSubmissionWithReset('position', e.target.value);
                  }
                }}
                disabled={disable}
              >
                <option value="">Select Position</option>
                {positionOptions.map((position) => (
                  <option key={position.value} value={position.value}>
                    {position.label}
                  </option>
                ))}
              </select>
            )}
          />
          {errors.position && (
            <div className="text-red-600">{'Position was required'}</div>
          )}
        </div>}

        <div className="mb-3">
          <label htmlFor="" className="form-label">
            Creative Type
          </label>
          <span className="text-red-600">*</span>
          <Controller
            name="creative_type"
            control={control}
            render={({ field }) => (
              <select
                {...field}
                className="form-select"
                aria-label="Default select example"
                onChange={(e) => {
                  field.onChange(e.target.value);
                  if (!isInitialLoad) {
                    handleFormSubmissionWithReset('creative_type', e.target.value);
                  }
                }}
                disabled={disable}
              >
                <option value="">select creative type</option>
                {watchedValues.package_type === "Classified" ? (
                  <option value="rectangle_classified">Rectangle Classified</option>
                ) : (
                  <>
                    <option value="Full Page">Full Image</option>
                    <option value="Full Page Video">Full Page Video</option>
                    <option value="Promoted Story">Promoted Story</option>
                  </>
                )}
              </select>
            )}
          />
          {errors.creative_type && (
            <div className="text-red-600">{'Creative type was required'}</div>
          )}
        </div>

        <div className="mb-3">
          <label htmlFor="" className="form-label">
            Package Weeks
          </label>
          <Controller
            name="package_weeks"
            control={control}
            render={({ field }) => (
              <select {...field} className="form-select" onChange={(e) => {
                field.onChange(e.target.value);
                if (!isInitialLoad) {
                  handleFormSubmissionWithReset('package_weeks', e.target.value);
                }
              }}
              disabled={disable}
              >
                <option value="">Select Weeks</option>
               {watchedValues.package_type === 'Local' ? LocalPricePackages.map(item => (
                <option key={item.value} value={item.value}>{item.label}</option>
               )) :pricePackages.map(item => (
                <option key={item.value} value={item.value}>{item.label}</option>
               ))}
              </select>
            )}
          />
          {errors.package_weeks && (
            <div className="text-red-600">{'Package weeks was required'}</div>
          )}
        </div>
        <h6 className="font-semibold">
          Base Package Value: {packageValue ?? 0}
        </h6>
        {isLoading && <div>Loading package details...</div>}

        <div className="mb-3 flex flex-wrap gap-4">
          {/* Final Value Input */}
          <div>
            <label htmlFor="final_package_value" className="form-label">
              Final Package Value
            </label>
            <input
              id="final_package_value"
              type="number"
              className="form-control border px-3 py-2 rounded-md"
              disabled={disable}
              value={updatedPackageValue ?? ""}
              onChange={(e) => setUpdatedPackageValue(Number(e.target.value))}
              placeholder="Enter Updated Package Value"
            />
          </div>

          {/* % Change */}
          <div>
            <label className="form-label">Percentage Change</label>
            <p className="font-semibold mt-1">
              {Math.round(percentChange(packageValue, updatedPackageValue))}%
            </p>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ZonePackage;
